import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';
import { useAxiosLoader } from './AxiosLoader';

const Loader = () => {
  const [loading] = useAxiosLoader();
  
  return(
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1300 }}
      open={loading}
    >
      <CircularProgress color="primary" />
    </Backdrop>    
  );
};

export default React.memo(Loader);
